<script>
import { required, minValue, maxValue, helpers } from 'vuelidate/lib/validators'

const isUnique = param => value => {
  return !helpers.req(value) || (param && param.indexOf(value) === -1)
}
export default {
  props: {
    value: { type: Array, default: () => [] },
    min: { type: Number },
    max: { type: Number },
    allowDuplicates: { type: Boolean, default: false },
    clearOnError: { type: Boolean, default: true },
    tagPrefix: { type: String },
    tagSuffix: { type: String }
  },
  data () {
    return {
      newTag: null,
      tags: []
    }
  },
  watch: {
    value: {
      handler (v) {
        this.tags = v ? [...v] : []
      },
      immediate: true
    }
  },
  validations () {
    let v = {
      required
    }

    if (this.min !== undefined) v['minValue'] = minValue(this.min)
    if (this.max !== undefined) v['maxValue'] = maxValue(this.max)

    if (!this.allowDuplicates) v['duplicate'] = isUnique(this.tags)

    return {
      newTag: {
        ...v
      }
    }
  },
  methods: {
    addTag (event) {
      event.preventDefault()

      if (!this.$v.$invalid) {
        this.tags.push(this.newTag)
        this.newTag = null
        this.$emit('input', this.tags)
      } else {
        if (this.clearOnError) this.newTag = null
      }
    },
    removeTag (index) {
      this.tags.splice(index, 1)
      this.$emit('input', this.tags)
    },
    removeLastTag (event) {
      if (event.target.value.length === 0) {
        this.removeTag(this.tags.length - 1)
        this.$emit('input', this.tags)
      }
    }
  }
}
</script>

<template>
  <div class="tag-input align-items-center form-control p-1 flex-wrap">
    <b-input-group>
      <div
        v-for="(tag, index) in tags"
        :key="tag"
        class="tag-input__tag px-2 py-1 mx-1 my-1 align-items-center d-flex rounded border-primary border"
      >
        <span>{{ tagPrefix }}</span>
        {{ tag }}
        <span>{{ tagSuffix }}</span>
        <i
          class="bx bx-x font-size-18 ml-2 pointer"
          @click="removeTag(index)"
        ></i>
      </div>
      <b-form-input
        type="text"
        v-bind="$attrs"
        class="tag-input__text my-1 p-0 mx-1"
        v-model.number.trim="newTag"
        @keydown.enter="addTag"
        @keydown.188="addTag"
        @keydown.delete="removeLastTag"
      />
    </b-input-group>
  </div>
</template>

<style scoped>
.tag-input {
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  box-sizing: border-box;
  min-height: calc(1.5em + 0.94rem + 2px);
  height: auto;
}

.tag-input__tag {
  font-size: 0.8em;
}

.tag-input__text {
  border: none;
  outline: none;
  background: none;
}
</style>
